'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The interface for a storage adapter
 *
 * @class
 * @abstract
 */
var StorageAdapter = function () {
  function StorageAdapter() {
    (0, _classCallCheck3.default)(this, StorageAdapter);
  }

  (0, _createClass3.default)(StorageAdapter, [{
    key: 'handleSetBatchStorage',

    // noinspection JSMethodCanBeStatic
    /**
     * Stores a list of values
     *
     * @public
     * @virtual
     * @method
     *
     * @param {Promise.<AppEventEmitter, Error>} dispatchPromise  a promise which resolve with an event dispatcher
     * @param {Array<{name:String, value:*}>} nameValuePairsList
     * @param {String} entityId the id of the entity to link the values to
     * @return {Promise<Array<{name:String, value:*}>, Error>}
     */
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dispatchPromise, nameValuePairsList, entityId) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSetBatchStorage(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleSetBatchStorage;
    }()
  }, {
    key: 'handleSetStorage',


    // noinspection JSMethodCanBeStatic
    /**
     * Stores a single value
     *
     * @public
     * @method
     * @virtual
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {*} value the value to store, will be `JSON serialized`
     * @param {String} entityId the id of the entity to link the values to
     * @return {Promise<*, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(dispatchPromise, name, value, entityId) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetStorage(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleSetStorage;
    }()
  }, {
    key: 'handleGetStorage',


    // noinspection JSMethodCanBeStatic
    /**
     * Retrieves a single value
     *
     * @public
     * @method
     * @virtual
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise  a promise which resolve with an event dispatcher
     * @param {String} name the name under which to store the value
     * @param {String} entityId the id of the entity which the value is linked to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise.<*, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dispatchPromise, name, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleGetStorage(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return handleGetStorage;
    }()
  }, {
    key: 'handleGetBatchStorage',


    /**
     * Retrieves a list of values
     *
     * @public
     * @method
     * @virtual
     *
     * @param {Promise<AppEventEmitter, Error>} dispatchPromise a promise which resolve with an event dispatcher
     * @param {Array<String>} nameList the list of value names to retrieve
     * @param {String} entityId the id of the entity which the values are linked to
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise.<Array<*>, Error>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(dispatchPromise, nameList, entityId) {
        var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                throw new Error('method must be implemented in a subclass');

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleGetBatchStorage(_x12, _x13, _x14) {
        return _ref4.apply(this, arguments);
      }

      return handleGetBatchStorage;
    }()
  }]);
  return StorageAdapter;
}();

exports.default = StorageAdapter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/StorageAdapter.js
// module id = 101
// module chunks = 0